import script from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=1c7b507c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7b507c"]])

export default __exports__